// Calibration runs in two phases: the DRY_RUN_* states are the marker-placement test, the
// CALIBRATION_* ones the real run that ends in ACTIVE.
export const DRISHTI_LIFECYCLE_STATE = {
    INSTALL_STARTED: 'INSTALL_STARTED',
    INSTALL_ENDED: 'INSTALL_ENDED',
    DRY_RUN_PENDING: 'DRY_RUN_PENDING',
    DRY_RUN_FAILED: 'DRY_RUN_FAILED',
    DRY_RUN_PASSED: 'DRY_RUN_PASSED',
    CALIBRATION_PENDING: 'CALIBRATION_PENDING',
    CALIBRATION_FAILED: 'CALIBRATION_FAILED',
    ESCALATED: 'ESCALATED',
    ACTIVE: 'ACTIVE',
} as const;
export type DrishtiLifecycleState = (typeof DRISHTI_LIFECYCLE_STATE)[keyof typeof DRISHTI_LIFECYCLE_STATE];

const DRISHTI_LIFECYCLE_STATES: readonly string[] = Object.values(DRISHTI_LIFECYCLE_STATE);

export const toDrishtiLifecycleState = (value: unknown): DrishtiLifecycleState | null =>
    typeof value === 'string' && DRISHTI_LIFECYCLE_STATES.includes(value) ? (value as DrishtiLifecycleState) : null;

export type DrishtiResumeRoute = '/drishti/guide' | '/drishti/calibration';

export const RESUME_PATH: Record<DrishtiLifecycleState, DrishtiResumeRoute> = {
    [DRISHTI_LIFECYCLE_STATE.INSTALL_STARTED]: '/drishti/guide',
    [DRISHTI_LIFECYCLE_STATE.INSTALL_ENDED]: '/drishti/calibration',
    [DRISHTI_LIFECYCLE_STATE.DRY_RUN_PENDING]: '/drishti/calibration',
    [DRISHTI_LIFECYCLE_STATE.DRY_RUN_FAILED]: '/drishti/calibration',
    [DRISHTI_LIFECYCLE_STATE.DRY_RUN_PASSED]: '/drishti/calibration',
    [DRISHTI_LIFECYCLE_STATE.CALIBRATION_PENDING]: '/drishti/calibration',
    [DRISHTI_LIFECYCLE_STATE.CALIBRATION_FAILED]: '/drishti/calibration',
    [DRISHTI_LIFECYCLE_STATE.ESCALATED]: '/drishti/calibration',
    [DRISHTI_LIFECYCLE_STATE.ACTIVE]: '/drishti/calibration',
};
